import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Table, TableModule } from "primeng/table";
import { InvoiceReviewSummaryService } from "../../../core/services/invoice-review-summary.service";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { OrderNotes } from "../../../core/models/invoice-review/orderNotes";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { LoaderService } from "../../../core/services/loader.service";
import { exportExcel } from "../../../core/services/shared.service";
import { CommonModule } from "@angular/common";
import { HidedynamicsdatePipe } from "../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "primeng/select";

@UntilDestroy()
@Component({
  selector: "jni-invoice-review-billing-notes-listing",
  templateUrl: "./invoice-review-billing-notes-listing.component.html",
  styleUrls: ["./invoice-review-billing-notes-listing.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    HidedynamicsdatePipe,
    FormsModule,
    SelectModule,
  ],
})
export class InvoiceReviewBillingNotesListingComponent implements OnInit {
  @Input() saleOrderId = "";
  @Output() selectedOrderNotesListing = new EventEmitter<OrderNotes[]>();
  @Output() scrollHiddenStatus = new EventEmitter();
  @Input() orderNotesGridListing: OrderNotes[] = [];

  @ViewChild("dt") table!: Table;

  purchaseOrderNumber: string[] = [];
  selectedOrderNotesGridListing: OrderNotes[] = [];
  orderNotesModalStatus = false;
  typeList = [
    {
      id: 1,
      name: "Billing note",
    },
    {
      id: 2,
      name: "Collections",
    },
    // 11286 - PGL-270 Remove Invoice Note option From All Note Forms
    // {
    //   id: 3,
    //   name: 'Invoice note'
    // },
    {
      id: 4,
      name: "Order note",
    },
  ];

  constructor(
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private router: ActivatedRoute,
    private _invoiceReviewSummaryService: InvoiceReviewSummaryService
  ) {
    this.router.params.subscribe(params => {
      this.saleOrderId = params["id"];
    });
  }

  ngOnInit(): void {
    if (this.saleOrderId) {
      this.getSalesOrderNotes(this.saleOrderId);
    }
  }

  getSalesOrderNotes(saleOrderId: string) {
    if (saleOrderId) {
      this._loaderService.setLoaderState(true);
      this._invoiceReviewSummaryService
        .getSalesOrderNotes(saleOrderId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              const billingNotes = res.data.filter(x =>
                x?.type?.toLowerCase()?.includes("billing")
              );
              this.orderNotesGridListing = billingNotes;
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Order note not found");
          },
        });
    }
  }

  exportExcel() {
    exportExcel(this.orderNotesGridListing, "Billing Orders");
  }
}
